import axios    from 'axios';

/* Constants */
import {GET_DATA_INE_NU, VALIDATE_CURP_NU} from "../constants";

/* Models */
import {sendExcpetions} from "../models/digitalOnboardingModel";

export const getSelfInfoDocuments = async  ( inef, iner, uiid, windowLoad, setModal, inftProspect, setInftProspect, setMessageIne, setErrors, setProcessOnboarding, param, setProgressoRegister, progressoRegister, setProgressoCounter, progressoCounter) =>  {

    let dataPayload = {
        "id":        inef,
        "idReverso": iner,
        "uuid":      uiid
    }

    windowLoad("Ya casi terminamos de consultar tú información...");

    try {
        const response = await axios({
          url:    GET_DATA_INE_NU,
          method: 'POST',
          data:   dataPayload
        });

        if(response.data.code === 200){
          
          windowLoad("Obtuvimos tu información correctamente...");

          let curpService = response.data.response.curp;
          let respIne     = response.data.response;

          validateCurp(windowLoad, setModal, uiid,  curpService, respIne, setMessageIne, inftProspect, setInftProspect, setErrors, setProcessOnboarding, param, setProgressoRegister, progressoRegister, setProgressoCounter, progressoCounter )
     
        }else{

          setMessageIne('takeTFoto');

          setModal((prevState) => {
            return { ...prevState, showModal: false }
          });

        }


    } catch (error) {

      setModal((prevState) => {
        return { ...prevState, showModal: false }
      });

      if(String(error.message) === "Network Error"){
        setMessageIne('errorRed');
      }else{
        setMessageIne('takeTFoto');
      }

    }

}
const validateCurp = async (windowLoad, setModal, uiid, curpService, respIne, setMessageIne, inftProspect, setInftProspect, setErrors, setProcessOnboarding, param, setProgressoRegister, progressoRegister, setProgressoCounter, progressoCounter) => {

  windowLoad("Preparando todo para terminar...")
  

  var response = respIne;

  let dataVCURP = {
    "curp": curpService,
    "documento": "0"
  }

  try {
    const respservice = await axios({
      url:    VALIDATE_CURP_NU,
      method: 'POST',
      data:   dataVCURP
    });

    if(respservice.data.code === 200){

      let curpService = respservice.data.response.curp;

      setErrors({});
      setProgressoRegister(parseInt(progressoRegister)+20);
      setProgressoCounter(parseInt(progressoCounter)+1);

      setMessageIne('dataIne');

      inftProspect['curp']              =  curpService;
      inftProspect['curpextra']         =  curpService;
      inftProspect['name']              =  response.nombres         != null  || response.nombres        != "null" ? response.nombres        : "";
      inftProspect['firstname']         =  response.primerApellido  != null  || response.primerApellido != "null" ? response.primerApellido : "";
      inftProspect['isfirstname']       =  response.primerApellido  === null || response.primerApellido === '' ? true : false;
      inftProspect['secondname']        =  response.segundoApellido != null  || response.segundoApellido != "null" ? response.segundoApellido : "";
      inftProspect['issecondname']      =  response.segundoApellido === null || response.segundoApellido === '' ? true : false;
      inftProspect['datebirday']        =  response.fechaNacimiento === null || response.fechaNacimiento === "" ||  response.fechaNacimiento === undefined ? respservice.data.response.fechaNacimiento  : response.fechaNacimiento;
      //inftProspect['sexo']              =  response.sexo === null || response.sexo === "" ? respservice.sexo === "Mujer" ? "M" : "H" : response.sexo 
      inftProspect['rfc']               =  curpService;
      inftProspect['claveelector']      =  response.claveElector;
      inftProspect['numeroine']         =  response.ocr;
                          
      inftProspect['municipyBirday']    =  '';
      inftProspect['stateBirday']       =  respservice.data.response.estadoNacimiento != null || respservice.data.response.estadoNacimiento != "null"  ? respservice.data.response.estadoNacimiento : "";
      inftProspect['countryBirday']     =  respservice.data.response.paisNacimiento   != null || respservice.data.response.paisNacimiento   != "null"  ? respservice.data.response.paisNacimiento : "";
                          
      inftProspect['calleine']          = response.calle   != null  || response.calle   != "null" ? response.calle   : "";
      inftProspect['coloniaine']        = response.colonia != null  || response.colonia != "null" ? response.colonia : "";
      inftProspect['ciudadine']         = response.ciudad  != null  || response.ciudad  != "null" ? response.ciudad  : "";

    }else if(respservice.data.code === 409){

      
      setMessageIne('dataIne');
      sendExcpetions(uiid, 0);

      inftProspect['curp']              =  response.curp;
      inftProspect['curpextra']         =  response.curp;
      inftProspect['name']              =  response.nombres         != null  || response.nombres        != "null" ? response.nombres        : "";
      inftProspect['firstname']         =  response.primerApellido  != null  || response.primerApellido != "null" ? response.primerApellido : "";
      inftProspect['isfirstname']       =  response.primerApellido  === null || response.primerApellido === '' ? true : false;
      inftProspect['secondname']        =  response.segundoApellido != null  || response.segundoApellido != "null" ? response.segundoApellido : "";
      inftProspect['issecondname']      =  response.segundoApellido === null || response.segundoApellido === '' ? true : false;
      inftProspect['datebirday']        =  response.fechaNacimiento === null || response.fechaNacimiento === "" ||  response.fechaNacimiento === undefined ? null  : response.fechaNacimiento;
      //inftProspect['sexo']              =  response.sexo === null || response.sexo === "" ? respservice.sexo === "Mujer" ? "M" : "H" : response.sexo 
      inftProspect['rfc']               =  response.curp;
      inftProspect['claveelector']      =  response.claveElector;
      inftProspect['numeroine']         =  response.ocr;
                          
      inftProspect['municipyBirday']    =  '';
      inftProspect['stateBirday']       =  "Modificar en captura";
      inftProspect['countryBirday']     =  "Modificar en captura";
                          
      inftProspect['calleine']          = response.calle   != null  || response.calle   != "null" ? response.calle   : "";
      inftProspect['coloniaine']        = response.colonia != null  || response.colonia != "null" ? response.colonia : "";
      inftProspect['ciudadine']         = response.ciudad  != null  || response.ciudad  != "null" ? response.ciudad  : "";

    }else{
      console.log("SIN DATA")
      //setMessageIne('takeFotoAgain');
    }

  } catch (error) {
    if(String(error.message) === "Network Error"){
      setMessageIne('errorRed');
    }else{
      //setMessageIne('errorCURP');
      setMessageIne('dataIne');
      sendExcpetions(uiid, 0);

      inftProspect['curp']              =  response.curp;
      inftProspect['curpextra']         =  response.curp;
      inftProspect['name']              =  response.nombres         != null  || response.nombres        != "null" ? response.nombres        : "";
      inftProspect['firstname']         =  response.primerApellido  != null  || response.primerApellido != "null" ? response.primerApellido : "";
      inftProspect['isfirstname']       =  response.primerApellido  === null || response.primerApellido === '' ? true : false;
      inftProspect['secondname']        =  response.segundoApellido != null  || response.segundoApellido != "null" ? response.segundoApellido : "";
      inftProspect['issecondname']      =  response.segundoApellido === null || response.segundoApellido === '' ? true : false;
      inftProspect['datebirday']        =  response.fechaNacimiento === null || response.fechaNacimiento === "" ? null ||  response.fechaNacimiento === undefined  : response.fechaNacimiento;
      //inftProspect['sexo']              =  response.sexo === null || response.sexo === "" ? respservice.sexo === "Mujer" ? "M" : "H" : response.sexo 
      inftProspect['rfc']               =  response.curp;
      inftProspect['claveelector']      =  response.claveElector;
      inftProspect['numeroine']         =  response.ocr;
                          
      inftProspect['municipyBirday']    =  '';
      inftProspect['stateBirday']       =  "Modificar en captura";
      inftProspect['countryBirday']     =  "Modificar en captura";
                          
      inftProspect['calleine']          = response.calle   != null  || response.calle   != "null" ? response.calle   : "";
      inftProspect['coloniaine']        = response.colonia != null  || response.colonia != "null" ? response.colonia : "";
      inftProspect['ciudadine']         = response.ciudad  != null  || response.ciudad  != "null" ? response.ciudad  : "";
      
    }
    
  }

  setProcessOnboarding(param);

  setInftProspect((prev) => {
    return { ...prev, ...inftProspect }
  });

  setModal((prevState) => {
    return { ...prevState, showModal: false }
  });

}